// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.eyefinity.ChangeEyefinityOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class ChangeEyefinityOrderRequest extends GandalfModelBase {

	@GandalfLabel('Comment')
	@GandalfValidator({ sizeString: { message: 'Comment cannot be longer than 200 characters', minLength: 0, maxLength: 200 } })
	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfLabel('VSP Order Detail')
	@GandalfValidator({ notNull: { message: 'VSP Order Detail is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	eyefinityOrderDetailId!: number;

}
